import React from 'react';
import { Table, Button, Spinner, Alert } from 'react-bootstrap';

const DriverList = ({ drivers, vehicles, loading, onEdit, onDelete }) => {
    if (loading) {
        return <Spinner animation="border" />;
    }

    if (drivers.length === 0) {
        return <Alert variant="info">No drivers found for this transporter.</Alert>;
    }

    return (
        <Table striped bordered hover responsive>
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Phone</th>
                    <th>License No</th>
                    <th>Vehicle</th>
                    <th>Status</th>
                    <th>Docs</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                {drivers.map(d => (
                    <tr key={d._id}>
                        <td>{d.name}</td>
                        <td>{d.phone}</td>
                        <td>{d.licenseNo}</td>
                        <td>{vehicles.find(v => v._id === d.vehicleId)?.vehicleNumber || 'N/A'}</td>
                        <td>
                            <span className={`badge bg-${d.isActive ? 'success' : 'danger'}`}>
                                {d.isActive ? 'Active' : 'Inactive'}
                            </span>
                        </td>
                        <td>
                            <div className="d-flex gap-1 flex-column">
                                {d.licenseDocUrl && (
                                    <a href={`${d.licenseDocUrl}`} target='_blank' rel="noreferrer" className="btn btn-secondary">License</a>
                                )}
                                {d.idProofDocUrl && (
                                    <a href={`${d.idProofDocUrl}`} target='_blank' rel="noreferrer" className="btn btn-secondary">ID Proof</a>
                                )}
                            </div>
                        </td>
                        <td>
                            <Button variant="info" size="sm" onClick={() => onEdit(d)} className="me-2">
                                Edit
                            </Button>
                            {d.isActive && (
                                <Button variant="danger" size="sm" onClick={() => onDelete(d)}>
                                    Deactivate
                                </Button>
                            )}
                        </td>
                    </tr>
                ))}
            </tbody>
        </Table>
    );
};

export default DriverList;
